import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useCreateCommentMutation } from '../../../store/api/commentApi';
import { sanitizeInput } from '../../../utils/sanitize';
import { Button } from '../../pieces/Button';

export function AddComment({ threadId }) {
  const [
    createComment,
    { isLoading: addingComment, isSuccess, isError, error },
  ] = useCreateCommentMutation();
  const [isShown, setIsShown] = useState(false);
  const [input, setInput] = useState('');

  const clean = sanitizeInput(input);
  const canSave = input !== '' && input !== '&nbsp' && !addingComment;

  const handleInput = (e) => {
    setIsShown(true);
    setInput(e.target.innerHTML);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (canSave) {
      await createComment({ threadId, comment: clean });
    }
  };

  useEffect(() => {
    if (isSuccess) {
      document.getElementById('commentInput').innerHTML = '';
      setInput('');
      setIsShown(false);
    }
  }, [isSuccess]);

  return (
    <form onSubmit={handleSubmit}>
      <div
        id="commentInput"
        aria-label="submit"
        contentEditable
        value={input}
        suppressContentEditableWarning
        onInput={handleInput}
        className="not-prose mt-4 overflow-hidden rounded-2xl px-4 py-3 [word-break:break-word] before:text-gray-900/50 empty:before:[content:'Add_a_reply...'] dark:before:text-gray-100/60"
        data-testid="add-comment"
      />
      {isError ? (
        <p id="errorMessage" className="text-red-500">
          {error.data.message}
        </p>
      ) : (
        ''
      )}
      {isShown ? (
        <div className="my-4">
          <div className="flex flex-row-reverse items-center gap-2">
            <Button
              size="base"
              variant="primary"
              type="submit"
              disabled={!canSave}
            >
              {addingComment ? 'Submitting...' : 'Submit'}
            </Button>

            <Button
              size="base"
              variant="tertiary"
              type="button"
              onClick={() => {
                document.getElementById('commentInput').innerHTML = '';
                setIsShown(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      ) : (
        ''
      )}
    </form>
  );
}

AddComment.propTypes = {
  threadId: PropTypes.string.isRequired,
};
